<template>
  <section class="_menu-section-style">
    <form-section label="Materiais" v-model="isExpanded.materials">
      <draggable ghost-class="ghost" :list="selectedSection.items" @start="isDragging = true" @end="isDragging = false">
        <transition-group type="transition" name="list-complete">      
          <div v-for="(opt, index) in selectedSection.items" :key="index" class="show-cursor bgHover" no-gutters>
            <Expansion 
              v-model="opt.visible" 
              :verticalExpansion="false"
              @click="onOpen(index, opt.visible)"
            >
              <template slot="default">
                <section class="d-flex flex-column mb-2">
                  <div class="styles-item">
                    <expanded-icon :isExpanded="opt.visible"/>
                    <span :style="`font-weight: ${opt.visible ? '700' : '400'}`">Material {{index + 1}}</span>
                    <div class="d-flex flex justify-end">
                      <DeleteButton @click="handleDelete(selectedSection.items, index)"/>       
                    </div>
                  </div>   
                </section>         
              </template>

              <template slot="expanded">
                <v-row no-gutters class="px-2 pb-6">
                  <v-col cols="12">
                    <TextField label="Título" v-model="opt.title"/>
                  </v-col>
                  <v-col cols="12" class="_pt">
                    <TextField label="Link Externo" v-model="opt.link"/>
                  </v-col>
                  <v-col cols="12" class="_pt">
                    <TextArea placeholder="Descrição" v-model="opt.description" :hideDetails="true"/>                    
                  </v-col>
                  <v-col cols="12" class="_pt">
                    <UploadImage v-model="selectedSection.items[index]" keyValue="media"/>
                  </v-col>
                </v-row>
              </template>
            </Expansion>

          </div>
        </transition-group>
      </draggable>

      <div class="d-flex flex-column _btn py-2">
        <ButtonV2 
          label="Novo material" 
          color="bt_gray_bg"
          textColor="darkBlue"
          textSize="0.80rem"
          icon="fa-solid fa-plus"
          @click="handleAdd"
        />         
      </div>
    </form-section> 

    <form-section label="Título" v-model="isExpanded.title">
      <Texts 
        textType="title" 
        :sectionType="selectedSection.type" 
        :selectedSection="selectedSection"
        :hide="['alignment']"
      />
    </form-section>

    <form-section label="Subtítulo" v-model="isExpanded.subtitle">
      <Texts 
        textType="subtitle" 
        :sectionType="selectedSection.type" 
        :selectedSection="selectedSection" 
        :hide="['alignment']"
        useTextArea
      />
    </form-section>

    <form-section label="Fundo" v-model="isExpanded.bg" :divider="false">
      <div class="pb-5">
        <ColorPickerV2 :colorSelected="selectedSection" type="item-color" title="Cor do fundo do item"/>
      </div>
      <Background 
        :selectedSection="selectedSection" 
        :sectionType="selectedSection.type"
        :availableTypes="['color', 'image']"
        @update="onUpdateBackground"
      />
    </form-section>
  </section>
</template>

<script>
import draggable from 'vuedraggable'
import { MATERIALS_ITEM_OPTION } from '../../../schemas/sections'
import FormSection from '../../_v2/utils/FormSection.vue'
import ExpandedIcon from '../../_v2/utils/ExpandedIcon.vue'
import UploadImage from '../../_v2/utils/UploadImage.vue'
import Texts from '../forms/formsV2/Texts.vue'
import Background from '../forms/formsV2/Background.vue'
import ButtonV2 from '../../_v2/ui/Button.vue'
import ColorPickerV2 from '../../_v2/ui/ColorPickerV2.vue'
import Expansion from '../../_v2/ui/Expansion.vue'
import TextField from '../../_v2/ui/TextField.vue'
import DeleteButton from '../../_v2/ui/DeleteButton.vue'
import TextArea from '../../_v2/ui/TextArea.vue'

export default {
  name: 'MaterialsSection',
  components: { 
    FormSection, 
    Texts, 
    Background, 
    ButtonV2, 
    draggable, 
    TextField, 
    TextArea, 
    ExpandedIcon, 
    DeleteButton, 
    Expansion, 
    UploadImage, 
    ColorPickerV2 
  },
  props: {
    selectedSection: {type: Object, required: true},
    sectionsId: {type: Array, required: true}
  },

  data: () => ({
    isExpanded: {title: false, subtitle: false, bg: false, materials: true},
  }),

  created () {
    this.selectedSection.items.forEach((item, index) => {
      item.visible = false
    })
  },

  methods: {
    onUpdateBackground ($event) {
      this.selectedSection.bg['background-type'] = $event['background-type']
      this.selectedSection.bg['background-image'] = $event['background-image']
    },

    onOpen (index, state) {
      if (state && this.selectedSection.items && this.selectedSection.items.length > 0) {
        this.selectedSection.items.forEach((option, i) => {
          if (i !== index) option.visible = false
        })
      }
    },

    handleAdd () {
      this.selectedSection.items.forEach(item => { item.visible = false })
      const newMaterial = MATERIALS_ITEM_OPTION()
      newMaterial.visible = true
      this.selectedSection.items.push(newMaterial)
    },

    handleDelete (array, index) {
      array.splice(index, 1)
    }
  }     
}
</script>

<style scoped>
  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
    cursor: move !important
  }

  .styles-item {
    display: flex;
    gap: 10px;
    height: 50px;
    align-items: center;
    font-size: 0.9rem;
    transition: all 0.3s;
    padding: 0 8px 0 8px;
    border-radius: 4px;
    overflow: hidden;
    white-space: nowrap;
  }

  .styles-item span {
    max-width: 70%;
    overflow: hidden;
    text-overflow: ellipsis;  
  }

  .styles-item:hover {
    cursor: pointer;
    animation: changeCursor 3s forwards;
  }

  .show-cursor {
    cursor: move !important;
    transition: all 0.3s;    
  }

  .show-cursor:hover {
    border-radius: 4px;
  }

  .bgHover:hover {
    background-color: #FAFBFB;    
  }

  @keyframes changeCursor {
    100% {
      cursor: move;
    }
  }

  .list-complete-item {
    transition: all 0.8s;
    display: inline-block;
    margin-right: 10px;
  }

  .list-complete-enter, .list-complete-leave-to {
    opacity: 0;
    transform: translateY(-30px);
  }

  .list-complete-leave-active {
    position: absolute;
    display: flex;
    align-items: center;
    width: 100%;
    height: 50px;
  }  
</style>